export const removeComments = <T,>(value: T): T => {
  if (Array.isArray(value)) {
    return value.map((item) => removeComments(item)) as T
  }

  if (value && typeof value === 'object') {
    return Object.entries(value).reduce((acc, [key, val]) => {
      if (key === 'comment') {
        return { ...acc, [key]: '' }
      }

      return { ...acc, [key]: removeComments(val) }
    }, {} as Record<string, unknown>) as T
  }

  return value
}